/**
 * Skeleton loader for the desktop Order Summary sidebar card.
 * Mirrors the loaded card's shell (white rounded-2xl bordered card) so the
 * loading → loaded transition doesn't shift the column. The page's sidebar
 * column owns visibility (hidden lg:block), width and stickiness.
 */
export function OrderSummarySkeleton() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <div className="space-y-6">
        {/* Title skeleton */}
        <div className="h-7 w-32 bg-gray-200 rounded motion-safe:animate-pulse" />

        {/* Totals skeleton */}
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex justify-between motion-safe:animate-pulse">
              <div className="h-4 w-24 bg-gray-200 rounded" />
              <div className="h-4 w-16 bg-gray-200 rounded" />
            </div>
          ))}
        </div>

        {/* Final total skeleton */}
        <div className="border-t border-gray-200 pt-4">
          <div className="flex justify-between motion-safe:animate-pulse">
            <div className="h-6 w-20 bg-gray-200 rounded" />
            <div className="h-6 w-24 bg-gray-200 rounded" />
          </div>
        </div>

        {/* Cart items skeleton */}
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex gap-3 motion-safe:animate-pulse">
              <div className="flex-1 space-y-2">
                <div className="h-4 w-3/4 bg-gray-200 rounded" />
                <div className="h-3 w-1/2 bg-gray-100 rounded" />
              </div>
              <div className="h-4 w-12 bg-gray-200 rounded" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
